export default __webpack_public_path__ + "static/media/One.6547424a.png";